// extracted by mini-css-extract-plugin
module.exports = {"settings":"_1Zm91htDhdquTtnzozkpX6"};